module.exports = __webpack_public_path__ + "static/media/ic_AI_voice@2x.098003b0.png";